
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  font-family:var(--ff-dmsans);
  -webkit-font-smoothing:antialiased;
}

.profile-teaser{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-8);
}

@media screen and (min-width: 1024px){

.profile-teaser{
    flex-direction:row
}
  }

.profile-card{
  display:flex;
  flex-direction:column;
  flex-basis:60%;
}

.profile-picture{
  width:min(100%, 400px);
  min-width:unset;
  flex-basis:40%;
}

.profile-picture img{
    width:100%;
    height:300px;
    object-fit:cover;
  }

.full-name{
  font-size:var(--fs-md);
  font-weight:var(--fw-bold);
}

.full-name a{
  text-decoration:none;
  color:var(--brand-primary-2);
}

.full-name a:hover{
    text-decoration:underline;
  }

.main-title{
  text-transform:uppercase;
  font-size:var(--fs-sm);
  font-weight:var(--fw-bold);
  margin:0;
}

.email{
  margin-top:1rem;
  overflow-wrap:anywhere;
}

.email,
.phone{
  color:var(--brand-primary-2);
  text-decoration:none;
  font-weight:var(--fw-bold);
}

.email:hover,
  .email:active,
  .phone:hover,
  .phone:active{
    text-decoration:underline;
  }

.office-label{
  font-size:var(--fs-lg);
}

.office-link{
  font-size:var(--fs-sm);
}

.office-link a{
    font-weight:var(--fw-bold);
    text-decoration:none;
    color:var(--brand-primary-2);
  }

.office-link a:hover{
  text-decoration:underline;
}

.offices-info{
  margin-top:var(--spacing-4);
  gap:var(--spacing-2) var(--spacing-16);
  display:flex;
  flex-wrap:wrap;
}

.offices-info ul{
    padding:0;
    margin:0;
  }

.offices-info li{
    list-style:none;
  }

.download-vcard{
  margin-top:var(--spacing-8);
  font-size:var(--fs-xl);
}
`;